/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthedRouteImport } from './routes/_unauthed'
import { Route as SandboxRouteImport } from './routes/_sandbox'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as UnauthedLoginRouteImport } from './routes/_unauthed/login'
import { Route as SandboxThemeRouteImport } from './routes/_sandbox/theme'
import { Route as SandboxSandboxRouteImport } from './routes/_sandbox/sandbox'
import { Route as SandboxBlocksRouteImport } from './routes/_sandbox/blocks'
import { Route as AuthedStudentRouteImport } from './routes/_authed/student'
import { Route as AuthedInstructorRouteImport } from './routes/_authed/instructor'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedStudentIndexRouteImport } from './routes/_authed/student/index'
import { Route as AuthedLogoutIndexRouteImport } from './routes/_authed/logout.index'
import { Route as AuthedInstructorIndexRouteImport } from './routes/_authed/instructor/index'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedStudentLogoutIndexRouteImport } from './routes/_authed/student/logout.index'
import { Route as AuthedInstructorLogoutIndexRouteImport } from './routes/_authed/instructor/logout.index'
import { Route as AuthedAdminVehiclesIndexRouteImport } from './routes/_authed/admin/vehicles.index'
import { Route as AuthedAdminStudentsIndexRouteImport } from './routes/_authed/admin/students.index'
import { Route as AuthedAdminStaffIndexRouteImport } from './routes/_authed/admin/staff.index'
import { Route as AuthedAdminReportsIndexRouteImport } from './routes/_authed/admin/reports.index'
import { Route as AuthedAdminRegistrationsIndexRouteImport } from './routes/_authed/admin/registrations.index'
import { Route as AuthedAdminProductsIndexRouteImport } from './routes/_authed/admin/products.index'
import { Route as AuthedAdminPayersIndexRouteImport } from './routes/_authed/admin/payers.index'
import { Route as AuthedAdminLocationsIndexRouteImport } from './routes/_authed/admin/locations.index'
import { Route as AuthedAdminEnrolmentsIndexRouteImport } from './routes/_authed/admin/enrolments.index'
import { Route as AuthedAdminDocumentTypesIndexRouteImport } from './routes/_authed/admin/document-types.index'
import { Route as AuthedAdminCoursesIndexRouteImport } from './routes/_authed/admin/courses.index'
import { Route as AuthedAdminClassroomsIndexRouteImport } from './routes/_authed/admin/classrooms.index'
import { Route as AuthedAdminCalendarsIndexRouteImport } from './routes/_authed/admin/calendars.index'
import { Route as AuthedAdminAccountIndexRouteImport } from './routes/_authed/admin/account.index'

const UnauthedRoute = UnauthedRouteImport.update({
  id: '/_unauthed',
  getParentRoute: () => rootRouteImport,
} as any)
const SandboxRoute = SandboxRouteImport.update({
  id: '/_sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const UnauthedLoginRoute = UnauthedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthedRoute,
} as any)
const SandboxThemeRoute = SandboxThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => SandboxRoute,
} as any)
const SandboxSandboxRoute = SandboxSandboxRouteImport.update({
  id: '/sandbox',
  path: '/sandbox',
  getParentRoute: () => SandboxRoute,
} as any)
const SandboxBlocksRoute = SandboxBlocksRouteImport.update({
  id: '/blocks',
  path: '/blocks',
  getParentRoute: () => SandboxRoute,
} as any)
const AuthedStudentRoute = AuthedStudentRouteImport.update({
  id: '/student',
  path: '/student',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInstructorRoute = AuthedInstructorRouteImport.update({
  id: '/instructor',
  path: '/instructor',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStudentIndexRoute = AuthedStudentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedStudentRoute,
} as any)
const AuthedLogoutIndexRoute = AuthedLogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInstructorIndexRoute = AuthedInstructorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedInstructorRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedStudentLogoutIndexRoute =
  AuthedStudentLogoutIndexRouteImport.update({
    id: '/logout/',
    path: '/logout/',
    getParentRoute: () => AuthedStudentRoute,
  } as any)
const AuthedInstructorLogoutIndexRoute =
  AuthedInstructorLogoutIndexRouteImport.update({
    id: '/logout/',
    path: '/logout/',
    getParentRoute: () => AuthedInstructorRoute,
  } as any)
const AuthedAdminVehiclesIndexRoute =
  AuthedAdminVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminStudentsIndexRoute =
  AuthedAdminStudentsIndexRouteImport.update({
    id: '/students/',
    path: '/students/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminStaffIndexRoute = AuthedAdminStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminReportsIndexRoute = AuthedAdminReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminRegistrationsIndexRoute =
  AuthedAdminRegistrationsIndexRouteImport.update({
    id: '/registrations/',
    path: '/registrations/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminProductsIndexRoute =
  AuthedAdminProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminPayersIndexRoute = AuthedAdminPayersIndexRouteImport.update({
  id: '/payers/',
  path: '/payers/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminLocationsIndexRoute =
  AuthedAdminLocationsIndexRouteImport.update({
    id: '/locations/',
    path: '/locations/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminEnrolmentsIndexRoute =
  AuthedAdminEnrolmentsIndexRouteImport.update({
    id: '/enrolments/',
    path: '/enrolments/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminDocumentTypesIndexRoute =
  AuthedAdminDocumentTypesIndexRouteImport.update({
    id: '/document-types/',
    path: '/document-types/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminCoursesIndexRoute = AuthedAdminCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminClassroomsIndexRoute =
  AuthedAdminClassroomsIndexRouteImport.update({
    id: '/classrooms/',
    path: '/classrooms/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminCalendarsIndexRoute =
  AuthedAdminCalendarsIndexRouteImport.update({
    id: '/calendars/',
    path: '/calendars/',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAccountIndexRoute = AuthedAdminAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AuthedAdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/instructor': typeof AuthedInstructorRouteWithChildren
  '/student': typeof AuthedStudentRouteWithChildren
  '/blocks': typeof SandboxBlocksRoute
  '/sandbox': typeof SandboxSandboxRoute
  '/theme': typeof SandboxThemeRoute
  '/login': typeof UnauthedLoginRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/instructor/': typeof AuthedInstructorIndexRoute
  '/logout/': typeof AuthedLogoutIndexRoute
  '/student/': typeof AuthedStudentIndexRoute
  '/admin/account/': typeof AuthedAdminAccountIndexRoute
  '/admin/calendars/': typeof AuthedAdminCalendarsIndexRoute
  '/admin/classrooms/': typeof AuthedAdminClassroomsIndexRoute
  '/admin/courses/': typeof AuthedAdminCoursesIndexRoute
  '/admin/document-types/': typeof AuthedAdminDocumentTypesIndexRoute
  '/admin/enrolments/': typeof AuthedAdminEnrolmentsIndexRoute
  '/admin/locations/': typeof AuthedAdminLocationsIndexRoute
  '/admin/payers/': typeof AuthedAdminPayersIndexRoute
  '/admin/products/': typeof AuthedAdminProductsIndexRoute
  '/admin/registrations/': typeof AuthedAdminRegistrationsIndexRoute
  '/admin/reports/': typeof AuthedAdminReportsIndexRoute
  '/admin/staff/': typeof AuthedAdminStaffIndexRoute
  '/admin/students/': typeof AuthedAdminStudentsIndexRoute
  '/admin/vehicles/': typeof AuthedAdminVehiclesIndexRoute
  '/instructor/logout/': typeof AuthedInstructorLogoutIndexRoute
  '/student/logout/': typeof AuthedStudentLogoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/blocks': typeof SandboxBlocksRoute
  '/sandbox': typeof SandboxSandboxRoute
  '/theme': typeof SandboxThemeRoute
  '/login': typeof UnauthedLoginRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/instructor': typeof AuthedInstructorIndexRoute
  '/logout': typeof AuthedLogoutIndexRoute
  '/student': typeof AuthedStudentIndexRoute
  '/admin/account': typeof AuthedAdminAccountIndexRoute
  '/admin/calendars': typeof AuthedAdminCalendarsIndexRoute
  '/admin/classrooms': typeof AuthedAdminClassroomsIndexRoute
  '/admin/courses': typeof AuthedAdminCoursesIndexRoute
  '/admin/document-types': typeof AuthedAdminDocumentTypesIndexRoute
  '/admin/enrolments': typeof AuthedAdminEnrolmentsIndexRoute
  '/admin/locations': typeof AuthedAdminLocationsIndexRoute
  '/admin/payers': typeof AuthedAdminPayersIndexRoute
  '/admin/products': typeof AuthedAdminProductsIndexRoute
  '/admin/registrations': typeof AuthedAdminRegistrationsIndexRoute
  '/admin/reports': typeof AuthedAdminReportsIndexRoute
  '/admin/staff': typeof AuthedAdminStaffIndexRoute
  '/admin/students': typeof AuthedAdminStudentsIndexRoute
  '/admin/vehicles': typeof AuthedAdminVehiclesIndexRoute
  '/instructor/logout': typeof AuthedInstructorLogoutIndexRoute
  '/student/logout': typeof AuthedStudentLogoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_sandbox': typeof SandboxRouteWithChildren
  '/_unauthed': typeof UnauthedRouteWithChildren
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/instructor': typeof AuthedInstructorRouteWithChildren
  '/_authed/student': typeof AuthedStudentRouteWithChildren
  '/_sandbox/blocks': typeof SandboxBlocksRoute
  '/_sandbox/sandbox': typeof SandboxSandboxRoute
  '/_sandbox/theme': typeof SandboxThemeRoute
  '/_unauthed/login': typeof UnauthedLoginRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/instructor/': typeof AuthedInstructorIndexRoute
  '/_authed/logout/': typeof AuthedLogoutIndexRoute
  '/_authed/student/': typeof AuthedStudentIndexRoute
  '/_authed/admin/account/': typeof AuthedAdminAccountIndexRoute
  '/_authed/admin/calendars/': typeof AuthedAdminCalendarsIndexRoute
  '/_authed/admin/classrooms/': typeof AuthedAdminClassroomsIndexRoute
  '/_authed/admin/courses/': typeof AuthedAdminCoursesIndexRoute
  '/_authed/admin/document-types/': typeof AuthedAdminDocumentTypesIndexRoute
  '/_authed/admin/enrolments/': typeof AuthedAdminEnrolmentsIndexRoute
  '/_authed/admin/locations/': typeof AuthedAdminLocationsIndexRoute
  '/_authed/admin/payers/': typeof AuthedAdminPayersIndexRoute
  '/_authed/admin/products/': typeof AuthedAdminProductsIndexRoute
  '/_authed/admin/registrations/': typeof AuthedAdminRegistrationsIndexRoute
  '/_authed/admin/reports/': typeof AuthedAdminReportsIndexRoute
  '/_authed/admin/staff/': typeof AuthedAdminStaffIndexRoute
  '/_authed/admin/students/': typeof AuthedAdminStudentsIndexRoute
  '/_authed/admin/vehicles/': typeof AuthedAdminVehiclesIndexRoute
  '/_authed/instructor/logout/': typeof AuthedInstructorLogoutIndexRoute
  '/_authed/student/logout/': typeof AuthedStudentLogoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/instructor'
    | '/student'
    | '/blocks'
    | '/sandbox'
    | '/theme'
    | '/login'
    | '/admin/'
    | '/instructor/'
    | '/logout/'
    | '/student/'
    | '/admin/account/'
    | '/admin/calendars/'
    | '/admin/classrooms/'
    | '/admin/courses/'
    | '/admin/document-types/'
    | '/admin/enrolments/'
    | '/admin/locations/'
    | '/admin/payers/'
    | '/admin/products/'
    | '/admin/registrations/'
    | '/admin/reports/'
    | '/admin/staff/'
    | '/admin/students/'
    | '/admin/vehicles/'
    | '/instructor/logout/'
    | '/student/logout/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blocks'
    | '/sandbox'
    | '/theme'
    | '/login'
    | '/admin'
    | '/instructor'
    | '/logout'
    | '/student'
    | '/admin/account'
    | '/admin/calendars'
    | '/admin/classrooms'
    | '/admin/courses'
    | '/admin/document-types'
    | '/admin/enrolments'
    | '/admin/locations'
    | '/admin/payers'
    | '/admin/products'
    | '/admin/registrations'
    | '/admin/reports'
    | '/admin/staff'
    | '/admin/students'
    | '/admin/vehicles'
    | '/instructor/logout'
    | '/student/logout'
  id:
    | '__root__'
    | '/_authed'
    | '/_sandbox'
    | '/_unauthed'
    | '/_authed/admin'
    | '/_authed/instructor'
    | '/_authed/student'
    | '/_sandbox/blocks'
    | '/_sandbox/sandbox'
    | '/_sandbox/theme'
    | '/_unauthed/login'
    | '/_authed/'
    | '/_authed/admin/'
    | '/_authed/instructor/'
    | '/_authed/logout/'
    | '/_authed/student/'
    | '/_authed/admin/account/'
    | '/_authed/admin/calendars/'
    | '/_authed/admin/classrooms/'
    | '/_authed/admin/courses/'
    | '/_authed/admin/document-types/'
    | '/_authed/admin/enrolments/'
    | '/_authed/admin/locations/'
    | '/_authed/admin/payers/'
    | '/_authed/admin/products/'
    | '/_authed/admin/registrations/'
    | '/_authed/admin/reports/'
    | '/_authed/admin/staff/'
    | '/_authed/admin/students/'
    | '/_authed/admin/vehicles/'
    | '/_authed/instructor/logout/'
    | '/_authed/student/logout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  SandboxRoute: typeof SandboxRouteWithChildren
  UnauthedRoute: typeof UnauthedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthed': {
      id: '/_unauthed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_sandbox': {
      id: '/_sandbox'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_unauthed/login': {
      id: '/_unauthed/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthedLoginRouteImport
      parentRoute: typeof UnauthedRoute
    }
    '/_sandbox/theme': {
      id: '/_sandbox/theme'
      path: '/theme'
      fullPath: '/theme'
      preLoaderRoute: typeof SandboxThemeRouteImport
      parentRoute: typeof SandboxRoute
    }
    '/_sandbox/sandbox': {
      id: '/_sandbox/sandbox'
      path: '/sandbox'
      fullPath: '/sandbox'
      preLoaderRoute: typeof SandboxSandboxRouteImport
      parentRoute: typeof SandboxRoute
    }
    '/_sandbox/blocks': {
      id: '/_sandbox/blocks'
      path: '/blocks'
      fullPath: '/blocks'
      preLoaderRoute: typeof SandboxBlocksRouteImport
      parentRoute: typeof SandboxRoute
    }
    '/_authed/student': {
      id: '/_authed/student'
      path: '/student'
      fullPath: '/student'
      preLoaderRoute: typeof AuthedStudentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/instructor': {
      id: '/_authed/instructor'
      path: '/instructor'
      fullPath: '/instructor'
      preLoaderRoute: typeof AuthedInstructorRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/student/': {
      id: '/_authed/student/'
      path: '/'
      fullPath: '/student/'
      preLoaderRoute: typeof AuthedStudentIndexRouteImport
      parentRoute: typeof AuthedStudentRoute
    }
    '/_authed/logout/': {
      id: '/_authed/logout/'
      path: '/logout'
      fullPath: '/logout/'
      preLoaderRoute: typeof AuthedLogoutIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/instructor/': {
      id: '/_authed/instructor/'
      path: '/'
      fullPath: '/instructor/'
      preLoaderRoute: typeof AuthedInstructorIndexRouteImport
      parentRoute: typeof AuthedInstructorRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/student/logout/': {
      id: '/_authed/student/logout/'
      path: '/logout'
      fullPath: '/student/logout/'
      preLoaderRoute: typeof AuthedStudentLogoutIndexRouteImport
      parentRoute: typeof AuthedStudentRoute
    }
    '/_authed/instructor/logout/': {
      id: '/_authed/instructor/logout/'
      path: '/logout'
      fullPath: '/instructor/logout/'
      preLoaderRoute: typeof AuthedInstructorLogoutIndexRouteImport
      parentRoute: typeof AuthedInstructorRoute
    }
    '/_authed/admin/vehicles/': {
      id: '/_authed/admin/vehicles/'
      path: '/vehicles'
      fullPath: '/admin/vehicles/'
      preLoaderRoute: typeof AuthedAdminVehiclesIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/students/': {
      id: '/_authed/admin/students/'
      path: '/students'
      fullPath: '/admin/students/'
      preLoaderRoute: typeof AuthedAdminStudentsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/staff/': {
      id: '/_authed/admin/staff/'
      path: '/staff'
      fullPath: '/admin/staff/'
      preLoaderRoute: typeof AuthedAdminStaffIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/reports/': {
      id: '/_authed/admin/reports/'
      path: '/reports'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof AuthedAdminReportsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/registrations/': {
      id: '/_authed/admin/registrations/'
      path: '/registrations'
      fullPath: '/admin/registrations/'
      preLoaderRoute: typeof AuthedAdminRegistrationsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/products/': {
      id: '/_authed/admin/products/'
      path: '/products'
      fullPath: '/admin/products/'
      preLoaderRoute: typeof AuthedAdminProductsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/payers/': {
      id: '/_authed/admin/payers/'
      path: '/payers'
      fullPath: '/admin/payers/'
      preLoaderRoute: typeof AuthedAdminPayersIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/locations/': {
      id: '/_authed/admin/locations/'
      path: '/locations'
      fullPath: '/admin/locations/'
      preLoaderRoute: typeof AuthedAdminLocationsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/enrolments/': {
      id: '/_authed/admin/enrolments/'
      path: '/enrolments'
      fullPath: '/admin/enrolments/'
      preLoaderRoute: typeof AuthedAdminEnrolmentsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/document-types/': {
      id: '/_authed/admin/document-types/'
      path: '/document-types'
      fullPath: '/admin/document-types/'
      preLoaderRoute: typeof AuthedAdminDocumentTypesIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/courses/': {
      id: '/_authed/admin/courses/'
      path: '/courses'
      fullPath: '/admin/courses/'
      preLoaderRoute: typeof AuthedAdminCoursesIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/classrooms/': {
      id: '/_authed/admin/classrooms/'
      path: '/classrooms'
      fullPath: '/admin/classrooms/'
      preLoaderRoute: typeof AuthedAdminClassroomsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/calendars/': {
      id: '/_authed/admin/calendars/'
      path: '/calendars'
      fullPath: '/admin/calendars/'
      preLoaderRoute: typeof AuthedAdminCalendarsIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/account/': {
      id: '/_authed/admin/account/'
      path: '/account'
      fullPath: '/admin/account/'
      preLoaderRoute: typeof AuthedAdminAccountIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedAdminAccountIndexRoute: typeof AuthedAdminAccountIndexRoute
  AuthedAdminCalendarsIndexRoute: typeof AuthedAdminCalendarsIndexRoute
  AuthedAdminClassroomsIndexRoute: typeof AuthedAdminClassroomsIndexRoute
  AuthedAdminCoursesIndexRoute: typeof AuthedAdminCoursesIndexRoute
  AuthedAdminDocumentTypesIndexRoute: typeof AuthedAdminDocumentTypesIndexRoute
  AuthedAdminEnrolmentsIndexRoute: typeof AuthedAdminEnrolmentsIndexRoute
  AuthedAdminLocationsIndexRoute: typeof AuthedAdminLocationsIndexRoute
  AuthedAdminPayersIndexRoute: typeof AuthedAdminPayersIndexRoute
  AuthedAdminProductsIndexRoute: typeof AuthedAdminProductsIndexRoute
  AuthedAdminRegistrationsIndexRoute: typeof AuthedAdminRegistrationsIndexRoute
  AuthedAdminReportsIndexRoute: typeof AuthedAdminReportsIndexRoute
  AuthedAdminStaffIndexRoute: typeof AuthedAdminStaffIndexRoute
  AuthedAdminStudentsIndexRoute: typeof AuthedAdminStudentsIndexRoute
  AuthedAdminVehiclesIndexRoute: typeof AuthedAdminVehiclesIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedAdminAccountIndexRoute: AuthedAdminAccountIndexRoute,
  AuthedAdminCalendarsIndexRoute: AuthedAdminCalendarsIndexRoute,
  AuthedAdminClassroomsIndexRoute: AuthedAdminClassroomsIndexRoute,
  AuthedAdminCoursesIndexRoute: AuthedAdminCoursesIndexRoute,
  AuthedAdminDocumentTypesIndexRoute: AuthedAdminDocumentTypesIndexRoute,
  AuthedAdminEnrolmentsIndexRoute: AuthedAdminEnrolmentsIndexRoute,
  AuthedAdminLocationsIndexRoute: AuthedAdminLocationsIndexRoute,
  AuthedAdminPayersIndexRoute: AuthedAdminPayersIndexRoute,
  AuthedAdminProductsIndexRoute: AuthedAdminProductsIndexRoute,
  AuthedAdminRegistrationsIndexRoute: AuthedAdminRegistrationsIndexRoute,
  AuthedAdminReportsIndexRoute: AuthedAdminReportsIndexRoute,
  AuthedAdminStaffIndexRoute: AuthedAdminStaffIndexRoute,
  AuthedAdminStudentsIndexRoute: AuthedAdminStudentsIndexRoute,
  AuthedAdminVehiclesIndexRoute: AuthedAdminVehiclesIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedInstructorRouteChildren {
  AuthedInstructorIndexRoute: typeof AuthedInstructorIndexRoute
  AuthedInstructorLogoutIndexRoute: typeof AuthedInstructorLogoutIndexRoute
}

const AuthedInstructorRouteChildren: AuthedInstructorRouteChildren = {
  AuthedInstructorIndexRoute: AuthedInstructorIndexRoute,
  AuthedInstructorLogoutIndexRoute: AuthedInstructorLogoutIndexRoute,
}

const AuthedInstructorRouteWithChildren =
  AuthedInstructorRoute._addFileChildren(AuthedInstructorRouteChildren)

interface AuthedStudentRouteChildren {
  AuthedStudentIndexRoute: typeof AuthedStudentIndexRoute
  AuthedStudentLogoutIndexRoute: typeof AuthedStudentLogoutIndexRoute
}

const AuthedStudentRouteChildren: AuthedStudentRouteChildren = {
  AuthedStudentIndexRoute: AuthedStudentIndexRoute,
  AuthedStudentLogoutIndexRoute: AuthedStudentLogoutIndexRoute,
}

const AuthedStudentRouteWithChildren = AuthedStudentRoute._addFileChildren(
  AuthedStudentRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedInstructorRoute: typeof AuthedInstructorRouteWithChildren
  AuthedStudentRoute: typeof AuthedStudentRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedLogoutIndexRoute: typeof AuthedLogoutIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedInstructorRoute: AuthedInstructorRouteWithChildren,
  AuthedStudentRoute: AuthedStudentRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedLogoutIndexRoute: AuthedLogoutIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface SandboxRouteChildren {
  SandboxBlocksRoute: typeof SandboxBlocksRoute
  SandboxSandboxRoute: typeof SandboxSandboxRoute
  SandboxThemeRoute: typeof SandboxThemeRoute
}

const SandboxRouteChildren: SandboxRouteChildren = {
  SandboxBlocksRoute: SandboxBlocksRoute,
  SandboxSandboxRoute: SandboxSandboxRoute,
  SandboxThemeRoute: SandboxThemeRoute,
}

const SandboxRouteWithChildren =
  SandboxRoute._addFileChildren(SandboxRouteChildren)

interface UnauthedRouteChildren {
  UnauthedLoginRoute: typeof UnauthedLoginRoute
}

const UnauthedRouteChildren: UnauthedRouteChildren = {
  UnauthedLoginRoute: UnauthedLoginRoute,
}

const UnauthedRouteWithChildren = UnauthedRoute._addFileChildren(
  UnauthedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  SandboxRoute: SandboxRouteWithChildren,
  UnauthedRoute: UnauthedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
